/* -------------------- helper -------------------- */
function onIdle(fn){('requestIdleCallback'in window)?
  requestIdleCallback(fn,{timeout:2e3}):setTimeout(fn,500);}

/* --------------- critical: run NOW -------------- */
(function(){
  /* 1) Auto-ID + wrap headings */
    const sel = [
    '.help-section h1',
    '.help-section h2',
    '.help-section h3',
    '.help-section h4',
    '.help-section h5',
    '.help-section h6',
    '.help-section strong',
    '.multicolumn:not(.enhanced-multicolumn) h2',
    '.multicolumn:not(.enhanced-multicolumn) h3',
    '.rich-text h2',
    '.rich-text h3',
    '.rich-text--heading',
    '.rich-text--heading h2',
    '.rich-text--heading h3',
    '.collapsible-content__heading',
    'details summary',
    '.section-header--title',
    '.how-it-works__heading',
    '.human-face__heading',
    '.sbn-heading'
  ].join(',');
  document.querySelectorAll(sel).forEach(t=>{
    const txt=t.innerText.trim();if(!txt)return;
    const base=txt.toLowerCase().replace(/[^a-z0-9]+/g,'-').replace(/^-+|-+$/g,'');
    if(!base)return;
    let id=base,c=1;while(document.getElementById(id))id=`${base}-${c++}`;
    t.id=id;
    if(!t.closest('summary')){
      const a=document.createElement('a');
      a.href=`#${id}`;a.textContent=t.textContent;
      a.style.cssText='text-decoration:none;color:inherit';
      t.innerHTML='';t.appendChild(a);
    }
  });

  /* 2) Shop-by-Need “Show/Hide Recommendations” */
  document.querySelectorAll('.shopbyneed').forEach(sec=>{
    const btn=sec.querySelector('.sbn-custom-button');
    const hid=sec.querySelector('.sbn-hidden');if(!btn||!hid)return;
    hid.style.cssText='max-height:0;overflow:hidden;transition:max-height .3s ease-in-out';
    btn.addEventListener('click',()=>{
      const open=hid.classList.toggle('expanded');
      hid.style.maxHeight=open?hid.scrollHeight+'px':'0';
      btn.textContent=open?'Hide Recommendations':'Show Recommended Products';
    });
  });

  /* 3) Shopify preview-bar title (theme-editor only) */
  

})(); /* ---- end critical ---- */

/* --------- non-critical: run when idle ---------- */
onIdle(()=>{

(function(){
  const isAccountHash=()=>{
    const path=location.pathname.replace(/\/$/,'');
    return path.endsWith('/account/login')&&(location.hash==='#recover'||location.hash==='#login');
  };

  const resetAccountHashScroll=()=>{
    if(!isAccountHash())return false;

    requestAnimationFrame(()=>{
      scrollTo({top:0,left:0,behavior:'auto'});
    });

    setTimeout(()=>{
      scrollTo({top:0,left:0,behavior:'auto'});
    },250);

    return true;
  };

  addEventListener('hashchange',resetAccountHashScroll);

  if(resetAccountHashScroll())return;

  const hash=location.hash;if(!hash)return;
  let tries=0,max=50;
  const t=setInterval(()=>{
    const el=document.querySelector(hash);
    if(el){
      clearInterval(t);
      const d=el.closest('details');if(d)d.open=true;
      setTimeout(()=>{
        const y=el.getBoundingClientRect().top+scrollY-150;
        scrollTo({top:y,behavior:'smooth'});
      },300);
    }
    if(++tries>=max)clearInterval(t);
  },200);
})();

addEventListener('click',e=>{
  const a=e.target.closest('a[href*="#"]');
  if(!a)return;

  const url=new URL(a.href,window.location.href);
  const hash=url.hash;

  if(!hash)return;

  const path=url.pathname.replace(/\/$/,'');

  if(path.endsWith('/account/login')&&(hash==='#recover'||hash==='#login')){
    return;
  }

  if(
    url.origin!==window.location.origin||
    url.pathname!==window.location.pathname||
    url.search!==window.location.search
  ){
    return;
  }

  const id=decodeURIComponent(hash.slice(1));
  const el=document.getElementById(id);

  if(!el)return;

  e.preventDefault();

  const d=el.closest('details');
  if(d&&!d.open)d.open=true;

  const y=el.getBoundingClientRect().top+scrollY-150;
  scrollTo({top:y,behavior:'smooth'});

  history.pushState(null,'',hash);
});

  /* C) Defer Shopify-injected third-party scripts */
  (function(){
    document.querySelectorAll('script[src]').forEach(s=>{
      if(/klaviyo|judge\.me|mailchimp|simprosys|google-analytics|facebook|hotjar/.test(s.src)){
        const c=document.createElement('script');
        c.src=s.src;c.defer=true;
        if(s.integrity)c.integrity=s.integrity;
        if(s.crossOrigin)c.crossOrigin=s.crossOrigin;
        s.remove();document.head.appendChild(c);
      }
    });
  })();

}); /* ---- end onIdle ---- */